import React from 'react'
import AppRouter from './AppRouter'
import { Container, makeStyles, Typography } from '@material-ui/core'
import ThemeProvider from './AppThemeProvider'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { Header, Footer } from './components/layout'
import DateFnsUtils from '@date-io/date-fns'

const App: React.FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.app}>
      <ThemeProvider>
          <Header /> 
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Container maxWidth="md" className={classes.appBody}>
              <Typography color="primary" variant="h1" gutterBottom className={classes.title}>
                Consumer Request Submission
              </Typography>
                <AppRouter />
            </Container>
          </MuiPickersUtilsProvider>
          <Footer />
      </ThemeProvider>
    </div>
  )
}

const useStyles = makeStyles({
  app: {
    display: 'block'
  },
  appBody: {
    height: '100%',
    minHeight: '100vh',
    marginTop: 100,
    marginBottom: 75
  },
  spinnerContainer: {    
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  title: { textAlign: 'center', paddingTop: 30, paddingBottom: 30 }
})

export default App
